import { combineReducers } from "redux";
import API from "./API.js";
import User from "./User";

const rootReducer = combineReducers({
  API,
  User
});

export default rootReducer;
